export default "__VITE_ASSET__BkJ1gssa__"